<ridango-dialog [size]="'460'" [visible]="showEmptiedDialog" (onClose)="onCloseEndedDialog()">
    <div class="dialog-title bold">
        {{ 'SHOPPING_CART_ENDED_DIALOG_TITLE' | translate }}
    </div>

    <div class="dialog-description">
        <p>{{ 'SHOPPING_CART_ENDED_DIALOG_TEXT' | translate }}</p>
    </div>

    <div class="dialog-buttons-area">
        <button class="btn btn--primary btn--maximal" (click)="onCloseEndedDialog()" #focus>Ok</button>
    </div>
</ridango-dialog>
